<template>
  <div v-html="field.description"/>
</template>
<script>

export default {
  props: {
    field: {
      type: Object,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// SubheaderRender.vue?29e70ca3